import React, { useContext } from 'react';

import { getQueryParams } from 'common/containers/QueueItemListContainer';
import { LocationContext } from 'common/containers/RouterContainer';
import cloneElementWithProps from 'common/core/cloneElementWithProps';

import 'css/components/subdomain/admin/_AdminQueue.scss';
import AdminQueueSpam from './AdminQueueSpam';
import AdminQueueUnified from './AdminQueueUnified';

const AdminQueueSwitch = (props: Record<string, unknown>) => {
  const location = useContext(LocationContext);
  const queryParams = getQueryParams(location);

  // A user can set their preferences to spam, ut then downgrade and lose access to spam.
  // To prevent crashes we don't allow the component to be rendered. Resetting prefs is handled by AdminQueue
  if (queryParams?.source === 'spam') {
    return cloneElementWithProps(<AdminQueueSpam />, props);
  }

  return cloneElementWithProps(<AdminQueueUnified />, props);
};

export default AdminQueueSwitch;
